import moment from 'moment';

// Where a booking sits on its own timeline:
//   service start ---- pre-live ---- kick-off ---- live ---- end
// A booking goes LIVE at service start, so the status alone cannot tell the two apart -
// only the kick-off time can.

export const isCurrentEventLive = (event) => event?.status === 'LIVE';

// Statuses of a booking that is still heading to air. LIVE is one of them; cancelled,
// postponed, failed and completed bookings are not lining up for anything.
const PRE_LIVE_STATUSES = ['PENDING', 'RECEIVED', 'CONFIRMED', 'CLIENT_CONFIRMED', 'AWAITING_SIGNAL', 'LIVE'];

export const isCurrentEventPreLive = (event, now = moment.utc()) => {
  if (!PRE_LIVE_STATUSES.includes(event?.status)) return false;

  // `|| null`: moment.utc(undefined) is *now*, which would read as a live line-up window.
  const serviceStart = moment.utc(event.serviceStartTime || event.lineupTime || null);
  const kickoff = moment.utc(event.startTime || null);

  if (!serviceStart.isValid() || !kickoff.isValid()) return false;

  return now.isBetween(serviceStart, kickoff, undefined, '[)');
};

// Pre-live wins over the LIVE status: on air, but before kick-off, is still line-up.
export const monitoringStateOf = (event, now = moment.utc()) => {
  if (isCurrentEventPreLive(event, now)) return 'pre-live';
  if (isCurrentEventLive(event)) return 'live';
  const start = moment.utc(event.lineupTime || event.startTime || null);
  return start.isValid() && start.isAfter(now) ? 'upcoming' : 'past';
};
